<template>
  <div class="flex flex-row w-full min-h-8" tabindex="0">


    <input class="flex-grow w-full z-10 p-1" type="text"
        v-model="inputValue"
        :placeholder="placeholder"
        @input="$emit('update:modelValue', inputValue)"
        @keyup.enter="onEnter"
        :data-ui="dataUi"
    />

    <div v-if="showClearButton" :data-ui="'clear-input'"  @click="clearInput" class="px-2 bg-white dark:bg-trader-dark-gray  flex justify-center items-center hover:bg-active hover:text-white cursor-pointer">
      <i class="fa-solid fa-circle-xmark"></i>
    </div>

    <div v-if="showSearchButton" @click="onEnter" class="px-2 bg-trader-dark-gray dark:bg-trader-darker-gray flex justify-center items-center hover:bg-active hover:text-white cursor-pointer">
      <i class="fa-solid fa-magnifying-glass"></i>
    </div>

  </div>
</template>

<script>
export default {
  name: 'TRInput',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: 'p-2 w-full my-2'
    },
    dataUi: {
      type: String,
      default: ''
    },
    onClear: {
      type: Function,
      default: () => {}
    },
    onEnter: {
      type: Function,
      default: () => {}
    },
    showClearButton: {
      type: Boolean,
      default: true
    },
    showSearchButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValue: this.modelValue
    };
  },
  watch: {
    modelValue(newValue) {
      this.inputValue = newValue;
    }
  },
  methods: {
    clearInput() {
      this.inputValue = '';
      this.$emit('update:modelValue', '');
    }
  },
  inheritAttrs: false
};
</script>

<style scoped>
/* Verhindert abgeschnittene Outline beim Fokus */
/*
.flex-row:focus-within {
  outline: 2px solid #007BFF;
  outline-offset: 4px;
}
*/
</style>
